/// <reference path="FilterPanelTypes.ts" />
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilterPanelOptionV2.html?raw';

import Multiselect from '../Multiselect/Multiselect';

import SearchSelect from '../SearchSelect/SearchSelect';

// interfaces für die Daten:
import "../../UI/FilterPanel/FilterPanelTypes";
import FilterPanelSection from './FilterPanelSection';
import DateTimeInput from '../DateTimeInput/DateTimeInput';
import Edit from '../Edit/Edit';
import ColorPicker from '../ColorPicker/ColorPicker';

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { TranslationHelpers } from "../../../more/Helpers";
import PlaintextEditContainer from '../Edit/PlaintextEditContainer/PlaintextEditContainer';
import _StatefulBase from '../_StatefulBase/_StatefulBase';
import NumberInput from '../NumberInput/NumberInput';
import DateInput from '../DateInput/DateInput';

class FilterPanelOptionV2 extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private labelNode: HTMLElement;
    private infoText_Content: HTMLElement;
    private infoText_Heading: HTMLElement;
    private infoText_Container: HTMLElement;
    
    private _targetInput:  MdsLax<InstanceType<typeof _StatefulBase>>;

    private txtParameterInfo: HTMLElement;


    private type: FilterOptionTypes = null; // combobox, selectentity... ?
    private label: string;// = "?";

    // Attribut oder sonstiger eindeutiger Bezeichner für die API zum Auslesen
    mandatory: boolean = false;
    valid: boolean = true;
    readonly: boolean = false;
    hidden: boolean = false;
    selected: boolean = false;
    emptyIfDeselected: boolean = false;
    section: MdsLax<InstanceType<typeof FilterPanelSection>> = null;

    alternativeMandatoryMode: boolean = false;

    private data: FilterPanelTypes.OptionConfig = null;
    private oldValue: any;

    private _setHiddenAttr(value: boolean) {

        this.hidden = value === true;

        this.hideNode(this.domNode, this.hidden);
    }

    getData(): FilterPanelTypes.OptionConfig {
        return this.data;
    }
    setData(data?: FilterPanelTypes.OptionConfig) {
        //console.trace("filteroption set data", data, this.data);

        if (!data) data = this.data;
        else {
            this.data = lang.clone(data);
        }

        data = this.data;
        //this._setTypeAttr(data.type as any);

        if (!data) {
            console.warn(this.id + ": no config data", this);
            return;
        }

        this.mandatory = data.isMandatory;

        // TYP SETZEN 
        {

            let bValidType = false;
            if (this.type) this.UiModder.domClass.remove(this.domNode, this.type);

            //console.debug("_setTypeAttr", value, this.data);

            if (this._targetInput) this._targetInput.destroy();

            let type = data.type;

            this.UiModder.domAttr.set(this.domNode, "data-option-type", type);

            // einblenden was jetzt gewählt ist:
            if (type == FilterOptionTypes.infotext) {
                this.type = type;

                this._targetInput = null; // bei Infotext sowieso nicht
                
                let value = data.value as string;
                if (TranslationHelpers.canTranslate(value)) value = TranslationHelpers.translate(value);

                this.setValue(value);


                bValidType = true;
            } else if (type == FilterOptionTypes.toggleButton) {
                this.type = type;

                this.data.value = this.data.selected;

                this._targetInput = null; // gibts beim Toggle nicht, weil das ja selber nur on/off kann

                bValidType = true;
            } else if (type == FilterOptionTypes.text || type == FilterOptionTypes.number || type == FilterOptionTypes.float) {
                this.type = type;

                
                if (type == FilterOptionTypes.float || type == FilterOptionTypes.number) {
                    this.type = type;

                    let numberInput = new NumberInput();
                    numberInput.placeAt(this.labelNode, "after");
                    this._targetInput = numberInput;

                    if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                        numberInput.setMinRange(this.data.minValue);
                    }
                    if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                        numberInput.setMaxRange(this.data.maxValue);
                    }

                    if (type == FilterOptionTypes.float) {
                        numberInput.setPlaces(2);
                    }
                } else {
                    // text
                    let textInput = new Edit();
                    textInput.placeAt(this.labelNode, "after");
                    this._targetInput = textInput;
                    if (this.data.maxLength > 0) {
                        textInput.setMaxLength(this.data.maxLength);
                    }
                    if (this.data.minLength > 1) {
                        textInput.setMinLength(this.data.minLength);
                    }
                }

                bValidType = true;
            } else if (type == FilterOptionTypes.date) {
                this.type = type;

                let dateInput = new DateInput();
                dateInput.placeAt(this.labelNode, "after");
                this._targetInput = dateInput;

                dateInput.on("change", lang.hitch(this, this._onChange_DateInput))

                bValidType = true;
            } else if (type == FilterOptionTypes.combobox) {
                this.type = type;

                let searchSelect = new SearchSelect();
                searchSelect.setCyName((this.section?.title ? this.section.title + ":" : "") + data.name);
                searchSelect.placeAt(this.labelNode, "after");
                this._targetInput = searchSelect;

                searchSelect.on( "change", lang.hitch(this, this._onChange_SelectInput));

               
                if (typeof (this.data.valueList) != "undefined") {

                    let values: Array<string> = [];
                    let labels: Array<string> = [];
                    let colors: Array<Partial<more.EntityAPIColor>> = [];
                    let preselected: string = this.data.value as string;
                    let selectable: Array<boolean> = [];

                    for (let i = 0; i < this.data.valueList.length; i++) {
                        let selectValueData = this.data.valueList[i];

                        values.push(selectValueData.value);
                        labels.push(selectValueData.label);
                        selectable.push(selectValueData.disabled != true);

                        if (selectValueData.colorBG && selectValueData.colorTXT) colors.push({
                            BackColor: {
                                Hex: selectValueData.colorBG
                            },
                            TextColor: {
                                Hex: selectValueData.colorTXT
                            }
                        } as Partial<more.EntityAPIColor>)
                    }

                    if (colors.length && colors.length == values.length) {
                        searchSelect.setOptionsWithColor(values, labels, colors, data.value as string, selectable);
                    } else {
                        searchSelect.setOptions(values, labels, data.value as string, selectable);
                    }

                }

                bValidType = true;
            } else if (type == FilterOptionTypes.multiselect) {
                this.type = type;

                let mSelect: MdsLax<InstanceType<typeof Multiselect>> = new Multiselect();
                mSelect.setCyName((this.section?.title ? this.section.title + ":" : "") + data.name);
                mSelect.placeAt(this.labelNode, "after");
                this._targetInput = mSelect;

                mSelect.on("change", lang.hitch(this, this._onChange_MultiSelectInput, mSelect));

                if (typeof (this.data.valueList) != "undefined") {
                    let values: Array<string> = [];
                    let labels: Array<string> = [];
                    let preselected: Array<boolean> = [];
                    let selectable: Array<boolean> = [];
                    let colors: Array<Partial<more.EntityAPIColor>> = [];

                    for (let i = 0; i < this.data.valueList.length; i++) {
                        let selectValueData = this.data.valueList[i];

                        values.push(selectValueData.value);
                        labels.push(selectValueData.label);
                        preselected.push(selectValueData.selected);
                        selectable.push(selectValueData.disabled != true);

                        if (selectValueData.colorBG && selectValueData.colorTXT) colors.push({
                            BackColor: {
                                Hex: selectValueData.colorBG
                            },
                            TextColor: {
                                Hex: selectValueData.colorTXT
                            }
                        } as Partial<more.EntityAPIColor>)

                    }

                    if (colors.length && colors.length == values.length) {
                        mSelect.setOptionsWithColor(values, labels, colors, preselected, selectable);
                    } else {
                        mSelect.setOptions(values, labels, preselected, selectable);
                    }

                    this.data.value = mSelect.getValue();
                }

                if (typeof (this.data.maxLength) != "undefined") {
                    if (this.data.maxLength < 1) {
                        this.data.maxLength = undefined;
                    }
                }

                bValidType = true;
            } else if (type == FilterOptionTypes.dualcolor || type == FilterOptionTypes.simplecolor) {
                this.type = type;


                let colorpicker: MdsLax<InstanceType<typeof ColorPicker>> = new ColorPicker();
                colorpicker.placeAt(this.labelNode, "after");
                this._targetInput = colorpicker;


                if (this.type == FilterOptionTypes.dualcolor) {
                    colorpicker.setUseTextColor(true);
                } else {
                    colorpicker.setUseTextColor(false);
                }

                colorpicker.setUsePreview(false);

                // wenn es schon eine value gibt, dann müssen wir sie jetzt schon einmal setzen und auslesen, sonst gibts dann blöde
                // change-Effekte wenn sich das Format beim ersten Initialisieren ändert.
                if (this.data?.value) {
                    //debugger;
                    colorpicker.setValue(this.data.value as any);
                    this.data.value = colorpicker.getDualColor(false, true) as any;
                }

                colorpicker.on("change", lang.hitch(this, this._onChange_ColorPickerInput, colorpicker));

                bValidType = true;
            } else if (type == FilterOptionTypes.datetime) {
                this.type = type;

                let dateTimeInput: MdsLax<InstanceType<typeof DateTimeInput>> = new DateTimeInput();
                dateTimeInput.placeAt(this.labelNode, "after");
                this._targetInput = dateTimeInput;

                dateTimeInput.on( "change", lang.hitch(this, this._onChange_DateTimeInput));
                
                bValidType = true;
            } else if (type == FilterOptionTypes.multilinetext) {
                this.type = type;

                let multilineEdit: MdsLax<InstanceType<typeof Edit>> = new Edit();
                multilineEdit.placeAt(this.labelNode, "after");
                this._targetInput = multilineEdit;

                multilineEdit.setIsResizeable("vertical");
                multilineEdit.setIsMultiline(true);
                multilineEdit.setRows(3);

                multilineEdit.on("change", lang.hitch(this, this._onChange_MultilineInput));

                if (typeof (this.data.maxLength) != "undefined") {
                    if (this.data.maxLength < 1) {
                        this.data.maxLength = undefined;
                    }
                }

                if (this.data.maxLength) multilineEdit.setMaxLength(this.data.maxLength);

                bValidType = true;
            } else if (type == FilterOptionTypes.htmledit) {
                this.type = type;

                let htmlInput: MdsLax<InstanceType<typeof PlaintextEditContainer>> = new PlaintextEditContainer();
                htmlInput.placeAt(this.labelNode, "after");
                this._targetInput = htmlInput as any;

                htmlInput.on("change", lang.hitch(this, this._onChange_HtmlEditInput));

                htmlInput.deactivatePlaintextEditor(true);

                bValidType = true;
            }

            if (this._targetInput) {
                this._targetInput.domNode.setAttribute("data-cy", data.name + ":" + this.type);
                this._targetInput.domNode.setAttribute("data-e2e-role", this.type);
                this.domNode.setAttribute("data-cy", data.name + ":filter_SelectButton");
                this.domNode.setAttribute("data-e2e-role", "button");
            }

            if (bValidType === true) {
                this.UiModder.domClass.add(this.domNode, this.type);
            } else {
                return;
            }
        }


        // MANDATORY
        {
            let alternativeMandatoryMode = this.alternativeMandatoryMode;

            if (typeof (alternativeMandatoryMode) == "boolean") {
                /* Die Filteroption wird ihr Select immer ausblenden und ist immer selektiert. 
                 * Dadurch können leere Werte abgeschickt werden.
                 * Falls die Option Pflicht ist, muss sie weiterhin ausgefüllt werden.     
               */
                this.alternativeMandatoryMode = alternativeMandatoryMode !== false;
            }

            if (this.type == FilterOptionTypes.infotext) return;

            this._handleMandatoryStyle();

            let previouslyValid = this.valid;

            this.validateValue();

            if (this.valid != previouslyValid) {
                this.emit("valueChanged");
            }
        }

        this.setName(data.name);
        this.setLabel(data.label);
        this.setInfoText(data.infoText);
        
        this.emptyIfDeselected = data.emptyValueIfDeselected === true;

        this.setValue(data.value);


        

        this.setAsSelected(data.selected === true);
    }

    private _handleMandatoryStyle() {
        let selectButtonHidden = this.mandatory === true || this.alternativeMandatoryMode == true;
        if (selectButtonHidden) {
            if (this.type == FilterOptionTypes.toggleButton) {
                selectButtonHidden = false;
            } else {
                this.setAsSelected(true);
            }

        }

        this.UiModder.domClass.toggle(this.domNode, "mandatory", selectButtonHidden);

    }

    private setName(value: string): void{
        this.data.name = value;
    }

    private setLabel(value: translatableString): void {
        if (TranslationHelpers.canTranslate(value)) value = TranslationHelpers.translate(value);

        this.label = value;
        //console.debug("_setLabelAttr", value, this.type, this._targetLabel);

        // alle Labels setzen
        this.UiModder.domAttr.set(this.labelNode, "innerHTML", this.label);
    }

    setInfoText(text: string) {
        if (TranslationHelpers.canTranslate(text)) text = TranslationHelpers.translate(text);

        this.UiModder.domAttr.set(this.txtParameterInfo, "innerHTML", text);
        this.hideNode(this.txtParameterInfo.parentElement, !text);
    }

    setReadonly(bReadonly: boolean) {
        this._setReadonlyAttr(bReadonly !== false);
    }
    private _setReadonlyAttr(value: boolean): void {

        this.readonly = value === true;

        this.disableNode(this.domNode, this.readonly);
    }

    private setAsSelected(value: boolean): void {

        //console.debug("_setSelectedAttr", value, this.data, "Mandatory?", this.mandatory);


        if (this.type == FilterOptionTypes.infotext) return;

        if (this.mandatory == true) {
            value = true;
        }

        this.data.selected = value === true;
        this.selected = this.data.selected;

        this.UiModder.domClass.toggle(this.domNode, "deselected", !this.data.selected);
        this.UiModder.domClass.toggle(this.domNode, "selected", this.data.selected);

        //this.emit("valueChanged", this);
        //this.emit("change", this);
    }

    getType(): FilterOptionTypes {
        return this.type;
    }
  
    focusInput() {
        let node = null;
        try {
            switch (this.type) {
                case FilterOptionTypes.combobox:
                case FilterOptionTypes.multiselect:
                    node = this._targetInput["input"];
                    break;

                default:
                    if (this._targetInput["inputNode"]) node = this._targetInput["inputNode"];
                    else if (this._targetInput["input"]) node = this._targetInput["input"];
                    else node = this._targetInput;
                    break;
            }

            if (node && node.focus) node.focus();
        } catch (ex) {

        }
    }

    setValue(value: string | number | boolean | Array<string>, suppressAutoSelect?: boolean): void {
        this.setOptionValue(value, false, suppressAutoSelect);
    }

    getValue(emptyIfDeselected: boolean = true): string | boolean | number | Array<string> {

        if (!this.data.selected) return null;

        if (this.type === FilterOptionTypes.htmledit) return btoa(this.data.value as string);

        return this.data.value;
    }

    private setOptionValue(value: string | number | boolean | Array<string>, bSkipInputChange?: boolean, suppressAutoSelect?: boolean): void {

        //console.debug("_setValueAttr", value);

        this.data.value = value;
     

        if (this.type == FilterOptionTypes.infotext) {
            this.hideNode(this.infoText_Content, !value);
            this.UiModder.domAttr.set(this.infoText_Content, "innerHTML", value);

        }

        else if (bSkipInputChange !== true) {
            if (this.type == FilterOptionTypes.toggleButton) {
                if (value == "true" || value === true) {
                    this.setAsSelected(true);
                } else {
                    this.setAsSelected(false);
                }
            } else if (this.type == FilterOptionTypes.multiselect ||
                this.type == FilterOptionTypes.multilinetext ||
                this.type == FilterOptionTypes.text ||
                this.type == FilterOptionTypes.number ||
                this.type == FilterOptionTypes.float ||
                this.type == FilterOptionTypes.date ||
                this.type == FilterOptionTypes.datetime ||
                this.type == FilterOptionTypes.combobox ||
                this.type == FilterOptionTypes.dualcolor ||
                this.type == FilterOptionTypes.simplecolor) {
                if (value) {
                    this._targetInput.setValue(value);
                }
            } else if (this.type == FilterOptionTypes.htmledit) {
                if (value) {
                    this._targetInput.setValue(value as any, true);
                }
            }
        }
        //} else if (this.type == FilterOptionTypes.date) {
        //    this.date_Input.value = <string>value;
        //}
        //else if (this.type == FilterOptionTypes.text) {
        //    this.text_Input.value = <string>value;
        //}

        if (value != this.oldValue) {
            this.validateValue();
            this.emit("valueChanged");
            this.emit("change", this);
        }
        this.oldValue = value;
    }

    private setMandatoryxxx(value: boolean, alternativeMandatoryMode?: boolean): void {
       
    }

    /**
    * Die Filteroption wird ihr Select immer ausblenden und ist immer selektiert. 
    * Dadurch können leere Werte abgeschickt werden.
    * Falls die Option Pflicht ist, muss sie weiterhin ausgefüllt werden.
    * @param bAlternateMode
    */
    setAlternativeMandatoryBehaviour(bAlternateMode: boolean) {
        this.alternativeMandatoryMode = bAlternateMode !== false;
        
        this._handleMandatoryStyle();
        this.validateValue();
    }

    toggleSelected(bOverride?: boolean): void {
        if (this.readonly === true) {
            return;
        }

        if (this.type == FilterOptionTypes.infotext) return;

        if (this.selected != true || bOverride === true) {
            this.setAsSelected(true);
        } else if (this.selected == true || bOverride === false) {
            this.setAsSelected(false);
        }

        // wenn die Option "ausleeren wenn abgewählt" aktiv ist, dann Wert auf leer stellen und raus:
        if (this.selected != true && this.emptyIfDeselected === true && this.type != FilterOptionTypes.toggleButton) {
            this.setValue(null);
            return;
        }

        this.validateValue(); // prüfen ob zb Datum ausgewählt, aber nicht eingetragen wurde
        this.emit("valueChanged");
        this.emit("change", this);

    }

    private _onClick_Domnode(evt: MouseEvent) {
        if (this.type == FilterOptionTypes.toggleButton) {
            this.toggleSelected();
            evt.stopPropagation();
        }
    }
    private _onClick_ToggleSelect(evt: Event): void {
        this.toggleSelected();
        evt.stopPropagation();
    }
    
    private _handleInputChangeTimeoutHandle: any = null;

    private _handleInputChangeDelayed(delay?: number): void {
        if (this._handleInputChangeTimeoutHandle != null) {
            clearTimeout(this._handleInputChangeTimeoutHandle);
            this._handleInputChangeTimeoutHandle = null;
        }

        if (typeof (delay) != "undefined" && delay > 0) {

        } else {
            delay = 400;
        }

        this._handleInputChangeTimeoutHandle = setTimeout(lang.hitch(this, this._handleInputChange), delay);
    }

    

    private _handleInputChange(): void {

        if (this.mandatory != true) {

            if (this.type == FilterOptionTypes.multiselect) {
                let mSelect = this._targetInput as MdsLax<InstanceType<typeof Multiselect>>;
                let value = mSelect.getValue();
                this.setAsSelected(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.datetime) {
                let dateTimeInput = this._targetInput as MdsLax<InstanceType<typeof DateTimeInput>>;
                let value = dateTimeInput.getValue()?.date;
                this.setAsSelected(!!value || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.date) {
                let dateInput = this._targetInput as MdsLax<InstanceType<typeof DateInput>>;
                let value = dateInput.getValue();
                this.setAsSelected(!!value || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.multilinetext ||
                this.type == FilterOptionTypes.text) {
                let edit = this._targetInput as MdsLax<InstanceType<typeof Edit>>;
                let value = edit.getValue() as string;
                this.setAsSelected(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.number ||
                this.type == FilterOptionTypes.float) {
                let numberInput = this._targetInput as MdsLax<InstanceType<typeof NumberInput>>;
                let value = numberInput.getValue() as number;
                this.setAsSelected(value != null || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.htmledit) {
                let edit = this._targetInput as any as MdsLax<InstanceType<typeof PlaintextEditContainer>>;
                let value = edit.getValue();
                this.setAsSelected(value?.length > 0 || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.combobox) {
                let select = this._targetInput as MdsLax<InstanceType<typeof SearchSelect>>;
                let value = select.getValue(false);
                this.setAsSelected(!!value || this.alternativeMandatoryMode == true);
            } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                let value = (this._targetInput as MdsLax<InstanceType<typeof ColorPicker>>).getColor(true);
                this.setAsSelected(!!value || this.alternativeMandatoryMode == true);
            } 
        }

        if (this.type == FilterOptionTypes.multiselect) {

            this.setOptionValue((this._targetInput as MdsLax<InstanceType<typeof Multiselect>>).getValue(), true);

        } else if (this.type == FilterOptionTypes.datetime) {

            this.setOptionValue(this.dateToLocalISOString((this._targetInput as MdsLax<InstanceType<typeof DateTimeInput>>).getValue()?.date), true);

        }else if (this.type == FilterOptionTypes.date) {

            this.setOptionValue(this.dateToLocalISOString((this._targetInput as MdsLax<InstanceType<typeof DateInput>>).getValue()), true);

        } else if (this.type == FilterOptionTypes.multilinetext ||
            this.type == FilterOptionTypes.text) {

            this.setOptionValue((this._targetInput as MdsLax<InstanceType<typeof Edit>>).getValue(), true);

        } else if (this.type == FilterOptionTypes.htmledit) {

            this.setOptionValue((this._targetInput as any as MdsLax<InstanceType<typeof PlaintextEditContainer>>).getValueBase64(), true);

        } else if (this.type == FilterOptionTypes.combobox) {

            this.setOptionValue((this._targetInput as MdsLax<InstanceType<typeof SearchSelect>>).getValue(false), true);

        } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {

            this.setOptionValue((this._targetInput as MdsLax<InstanceType<typeof ColorPicker>>).getDualColor(false, true) as any);

        } else if (this.type == FilterOptionTypes.float ||
            this.type == FilterOptionTypes.number) {

            this.setOptionValue((this._targetInput as MdsLax<InstanceType<typeof NumberInput>>).getValue() as number, true);

        }       
    }

    private _onChange_DateInput(evt: Event): void {
        //console.debug("_onChange_DateInput", this.date_Input.value);

        this._handleInputChange();
    }

    private _onChange_SelectInput(evt: Event): void {
        
        this._handleInputChange();

        //console.trace("_onChange_SelectInput", this.select_Widget, this.data);
    }

    private _onChange_TextInput(evt: Event): void {
        //console.debug("_onChange_TextInput", this.text_Input.value);
        this._handleInputChange();
    }

    private _onKeyUp_TextInput(evt: Event): void {
        this._handleInputChangeDelayed(222);
        setTimeout(lang.hitch(this, this.emit, "keyUp", evt), 50);
    }

    private _onChange_ColorPickerInput(): void {
        this._handleInputChange();
    }

    private _onChange_MultiSelectInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_MultilineInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_HtmlEditInput(evt: Event): void {
        this._handleInputChange();
    }
    private _onChange_DateTimeInput(evt: Event): void {
        this._handleInputChange();
    }

    private validateValue(): boolean {
        var bSetToWarning = false;

        if (this.type == FilterOptionTypes.infotext) {
            this.valid = true;
            return this.valid;
        }

        if (!this.mandatory && (this.data.selected == true && this.alternativeMandatoryMode != true) ||
            this.mandatory) {
            // ausgewählt, aber kein Wert -> deshalb Warnung

            if (this.type == FilterOptionTypes.multiselect) {
                bSetToWarning = (this._targetInput as MdsLax<InstanceType<typeof Multiselect>>).getValue()?.length <= 0;
            } else if (this.type == FilterOptionTypes.datetime) {
                bSetToWarning = !(this._targetInput as MdsLax<InstanceType<typeof DateTimeInput>>).getValue()?.date;
            } else if (this.type == FilterOptionTypes.date) {
                bSetToWarning = !(this._targetInput as MdsLax<InstanceType<typeof DateInput>>).getValue();
            } else if (this.type == FilterOptionTypes.multilinetext ||
                this.type == FilterOptionTypes.text) {
                bSetToWarning = !(this._targetInput as MdsLax<InstanceType<typeof Edit>>).getValue();
            } else if (this.type == FilterOptionTypes.number ||
                this.type == FilterOptionTypes.float) {
                bSetToWarning = (this._targetInput as MdsLax<InstanceType<typeof NumberInput>>).getValue() == null;
            } else if (this.type == FilterOptionTypes.htmledit) {
                bSetToWarning = !(this._targetInput as any as MdsLax<InstanceType<typeof PlaintextEditContainer>>).getValue();
            } else if (this.type == FilterOptionTypes.combobox) {
                bSetToWarning = !(this._targetInput as MdsLax<InstanceType<typeof SearchSelect>>).getValue(false);
            } else if (this.type == FilterOptionTypes.dualcolor || this.type == FilterOptionTypes.simplecolor) {
                bSetToWarning = !(this._targetInput as MdsLax<InstanceType<typeof ColorPicker>>).getValue("full", true);
            }

        }
        

        if (this.type != FilterOptionTypes.toggleButton) {
            if (bSetToWarning != true) {
                if (this.type == FilterOptionTypes.text ||
                    this.type == FilterOptionTypes.multilinetext) {

                    let value = (this._targetInput as MdsLax<InstanceType<typeof Edit>>).getValue();

                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || value?.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || value?.length < this.data.minLength;
                        }
                    }
                }

                if (this.type == FilterOptionTypes.htmledit) {
                    let value = (this._targetInput as any as MdsLax<InstanceType<typeof PlaintextEditContainer>>).getValue();

                    if (this.selected == true) {
                        if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                            bSetToWarning = bSetToWarning || value?.length > this.data.maxLength;
                        }
                        if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                            bSetToWarning = bSetToWarning || value?.length < this.data.minLength;
                        }
                    }
                }

                
                if (this.type == FilterOptionTypes.date) {
                    let datevalue = (this._targetInput as MdsLax<InstanceType<typeof DateInput>>).getValue();

                    if (this.selected == true && datevalue) {
                        if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                            let compareDate = new Date(this.data.maxValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() > compareDate.valueOf();
                        }
                        if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                            let compareDate = new Date(this.data.minValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() < compareDate.valueOf();
                        }
                    }
                }
                if (this.type == FilterOptionTypes.datetime) {
                    let datevalue = (this._targetInput as MdsLax<InstanceType<typeof DateTimeInput>>).getValue()?.date;

                    if (this.selected == true && datevalue) {
                        if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                            let compareDate = new Date(this.data.maxValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() > compareDate.valueOf();
                        }
                        if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                            let compareDate = new Date(this.data.minValue);
                            bSetToWarning = bSetToWarning || datevalue.valueOf() < compareDate.valueOf();
                        }
                    }
                }

                if ((this.type == FilterOptionTypes.number || this.type == FilterOptionTypes.float)) {
                    let value = (this._targetInput as MdsLax<InstanceType<typeof NumberInput>>).getValue() as number;
                    if (typeof (this.data.maxValue) != "undefined" && this.data.maxValue != null) {
                        bSetToWarning = bSetToWarning || value > this.data.maxValue;
                    }
                    if (typeof (this.data.minValue) != "undefined" && this.data.minValue != null) {
                        bSetToWarning = bSetToWarning || value < this.data.minValue;
                    }
                }

                if (this.type == FilterOptionTypes.multiselect) {
                    let value = (this._targetInput as MdsLax<InstanceType<typeof Multiselect>>).getValue();

                    if (typeof (this.data.maxLength) != "undefined" && this.data.maxLength != null) {
                        bSetToWarning = bSetToWarning || value?.length > this.data.maxLength;
                    }
                    if (typeof (this.data.minLength) != "undefined" && this.data.minLength != null) {
                        bSetToWarning = bSetToWarning || value?.length < this.data.minLength;
                    }
                }
            }
        }

        this.UiModder.domClass.toggle(this.domNode, "invalid", bSetToWarning);

        this.valid = bSetToWarning != true;
        return this.valid;
    }


    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.data = {
            type: FilterOptionTypes.toggleButton,
            isMandatory: false,
            label: "?",
            name: "?",
            selected: false,
            value: "??"
        };
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //console.debug("FPopt postcreate", this.data);
        
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FilterPanelOptionV2);
